"use client";
import { useState as y, useCallback as n } from "react";
import { fileMatchesAccept as D } from "../../../utils/utils.mjs";
const $ = (o, k = {}) => {
  const { accept: s, maxSizeBytes: u, onFileSelected: m, error: w, onError: f, value: _ } = k, l = _ !== void 0, [x, p] = y(null), [C, h] = y(!1), [F, a] = y(null), [P, c] = y(null), M = l ? _ ?? null : x, E = w ?? F, S = C ? "loading" : E ? "error" : M ? "success" : "default", g = n(
    (e, r, t) => {
      const v = f == null ? void 0 : f({ type: e, file: r, defaultMessage: t });
      return typeof v == "string" ? v : t;
    },
    [f]
  ), i = n(() => {
    p(null), h(!1), a(null), c(null), o.current && (o.current.value = "");
  }, [o]), z = n(() => {
    var e;
    (e = o.current) == null || e.click();
  }, [o]), d = n(
    async (e) => {
      if (s != null && s.length && !D(e, s)) {
        const r = `Unsupported file type. Please upload a ${s.join(", ")} file.`;
        c("unsupported_type"), a(g("unsupported_type", e, r)), l || p(null);
        return;
      }
      if (u && e.size > u) {
        const r = `File exceeds the ${Math.round(u / 1024 / 1024)} MB limit. Please upload a smaller file.`;
        c("file_too_large"), a(g("file_too_large", e, r)), l || p(null);
        return;
      }
      if (l || p(e), a(null), c(null), !!m) {
        h(!0);
        try {
          await m(e);
        } catch (r) {
          const t = r instanceof Error ? r.message : "An error occurred processing the file";
          c("processing_error"), a(g("processing_error", e, t));
        } finally {
          h(!1);
        }
      }
    },
    [s, u, m, g, l]
  ), A = n(
    async (e) => {
      var t;
      const r = (t = e.target.files) == null ? void 0 : t[0];
      if (!r) {
        i();
        return;
      }
      await d(r);
    },
    [d, i]
  ), B = n(
    async (e) => {
      const r = e[0];
      if (!r) {
        i();
        return;
      }
      await d(r);
    },
    [d, i]
  );
  return { state: S, file: M, error: E, errorType: P, handleChange: A, handleDrop: B, openFilePicker: z, reset: i };
};
export {
  $ as useFileInput
};
